import { render } from "./Star.vue?vue&type=template&id=26853864&scoped=true"
import script from "./Star.vue?vue&type=script&lang=ts"
export * from "./Star.vue?vue&type=script&lang=ts"

import "./Star.vue?vue&type=style&index=0&id=26853864&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-26853864"

export default script